<template>
  <div>
    <fieldset>
      <div class="row">
        <div class="col-md-4 d-flex align-items-center">
          <label class="form-check-label" for="allowuseredit"
            >Allow add/edit users:</label
          >
         
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="allowuseredit"
              v-model="form.allowuseredit"
            />
          
        </div>

        <div class="col-md-4 d-flex align-items-center">
          <label class="form-check-label" for="allowmultiuseredit"
            >Multi-client add/edit users:</label
          >

            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="allowmultiuseredit"
              v-model="form.allowmultiuseredit"
            />
       
        </div>

        <div class="col-md-4 d-flex align-items-center">
          <label class="form-check-label" for="showselectproducts"
            >Show select products:</label
          >
       
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showselectproducts"
              v-model="form.showselectproducts"
            />
        
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="showbroadcastemail"
            >Show send email to users:</label
          >
     
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showbroadcastemail"
              v-model="form.showbroadcastemail"
            />
         
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="side_ShowAddPointsLink"
            >Show "Add Points" link on side bar:</label
          >
       
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="side_ShowAddPointsLink"
              v-model="form.side_ShowAddPointsLink"
            />
         
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="side_ShowAddPointsLink"
            >Show "Add All" & "Remove All" buttons in add points tool:</label
          >
         
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="AddPoints_ShowAllButtons"
              v-model="form.AddPoints_ShowAllButtons"
            />
          
        </div>

        <div class="col-md-4 d-flex align-items-center">
          <label class="form-check-label" for="allowBatchUpload"
            >Allow batch points upload:</label
          >
        
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="allowBatchUpload"
              v-model="form.allowBatchUpload"
            />
        
        </div>

        <div class="col-md-4 d-flex align-items-center">
          <label class="form-check-label" for="useCo_Address"
            >Default to co. address:</label
          >
          
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="useCo_Address"
              v-model="form.useCo_Address"
            />
         
        </div>

        <div class="col-md-4 d-flex align-items-center">
          <label class="form-check-label" for="allowPopup"
            >Show pop-up admin:</label
          >
      
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="allowPopup"
              v-model="form.allowPopup"
            />
         
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="showNewAdmin"
            >Show new admin:</label
          >
       
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showNewAdmin"
              v-model="form.showNewAdmin"
            />
        
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="orderApproval"
            >Client approved orders:</label
          >
        
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="orderApproval"
              v-model="form.orderApproval"
            />
          
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="allowBatchUpload"
            >Enable service excellence:</label
          >
          
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="allowSExcellence"
              v-model="form.allowSExcellence"
            />
          
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="allowQuiz"
            >Show quiz admin:</label
          >
     
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="allowQuiz"
              v-model="form.allowQuiz"
            />
        
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
export default {
  name: "ClientAdmins",
  data() {
    return {};
  },
  computed: {
    form() {
      return this.$store.state.manageClients.form;
    },
  },
};
</script>
<style></style>
